import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upgrade',
  templateUrl: './upgrade.component.html',
  styleUrls: ['./upgrade.component.css'],
  standalone: false
})
export class UpgradeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
